import classNames from 'classnames';
import css from '../knowledge-base.module.scss';

interface Props {
  title: string;
  onClick: () => void;
  isActive: boolean;
}

function MaterialsListItem({ title, onClick, isActive }: Readonly<Props>) {
  return (
    <li className={classNames(css.listItem, { [css.activeItem]: isActive })} onClick={onClick} /* NOSONAR */>
      {title}
    </li>
  );
}

export default MaterialsListItem;
